import styled from 'styled-components';

export const StyledAnswersList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;
